module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00015-fs8.bdaaae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00015-fs8.png
// module id = 168
// module chunks = 0